import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import PublicLayout from '../layouts/PublicLayout';
import Home from '../pages/public/Home';
import JobListings from '../pages/public/JobListings';
import JobDetail from '../pages/public/JobDetail';
import About from '../pages/public/About';
import Contact from '../pages/public/Contact';
import PrivacyPolicy from '../pages/public/PrivacyPolicy';
import TermsAndConditions from '../pages/public/TermsAndConditions';
import BlogListings from '../pages/public/BlogListings';
import BlogDetail from '../pages/public/BlogDetail';
import AiMatchProfile from '../pages/public/AiMatchProfile';
import ResumeBuilder from '../pages/public/ResumeBuilder';

import { ThemeProvider } from '../contexts/ThemeContext';

//import Login from "../pages/candidate/Auth/Login";

/*import Login from '../pages/public/Login';
import SignupCandidate from '../pages/public/SignupCandidate'; */

/*const LoginPlaceholder = () => (
    <div className="min-h-screen pt-24 pb-16 container mx-auto px-4">
        <h1 className="text-4xl font-bold mb-6">Login</h1>
        <p className="text-gray-300">Login page content coming soon...</p>
    </div>
);*/

const SignupCandidatePlaceholder = () => (
    <div className="min-h-screen pt-24 pb-16 container mx-auto px-4">
        <h1 className="text-4xl font-bold mb-6">Sign Up as Candidate</h1>
        <p className="text-gray-300">Signup page content coming soon...</p>
    </div>
);

const PublicRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<PublicLayout />}>
                <Route index element={<Home />} />
                <Route 
                    path="/jobs" 
                    element={
                        <ThemeProvider theme="public">
                            <JobListings />
                        </ThemeProvider>
                    } 
                />
                <Route 
                    path="/jobs/:id" 
                    element={
                        <ThemeProvider theme="public">
                            <JobDetail />
                        </ThemeProvider>
                    } 
                />

                {/* <Route path="jobs" element={<JobListings />} />
                <Route path="jobs/:id" element={<JobDetail />} /> */}

                <Route path="about" element={<About />} />
                <Route path="contact" element={<Contact />} />
                <Route path="privacy-policy" element={<PrivacyPolicy />} />
                <Route path="terms-and-conditions" element={<TermsAndConditions />} />
                <Route path="blog" element={<BlogListings />} />
                <Route path="blog/:slug" element={<BlogDetail />} />
                <Route path="ai-match-profile" element={<AiMatchProfile />} />
                <Route path="resume-builder" element={<ResumeBuilder />} />

                {/* <Route path="login" element={<Login />} /> */}
                {/* <Route path="signup" element={<SignupCandidatePlaceholder />} /> */}
                <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
        </Routes>
    );
};

export default PublicRoutes;